import { render, staticRenderFns } from "./MediaSearchLinks.vue?vue&type=template&id=053e8f83&scoped=true&lang=pug"
import script from "./MediaSearchLinks.vue?vue&type=script&lang=js"
export * from "./MediaSearchLinks.vue?vue&type=script&lang=js"
import style0 from "./MediaSearchLinks.vue?vue&type=style&index=0&id=053e8f83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e8f83",
  null
  
)

export default component.exports